import { Component, OnInit, Input } from '@angular/core';
import { LabelsService } from '../../services/labels/labels.service';

@Component({
  selector: 'lbl',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss']
})
export class LabelComponent implements OnInit {

  @Input() id: string = "";
  @Input() uppercase: string | boolean = "";

  public text : string = "";

  constructor(private labelService : LabelsService) { }

  ngOnInit() {
    this.text = this.convert(this.labelService.get(this.id) || "");
  }


  private convert(string){
    let text = string;

    if(text.length > 0){
      if(this.uppercase == "first"){
        text = text.charAt(0).toUpperCase() + text.substr(1);
      }
  
      if(this.uppercase == true || this.uppercase == "true"){
        text.toUpperCase();
      }
    }
    return text;
  }
}